module.exports = __webpack_public_path__ + "static/tbo-6717310155579c15000dbe31e017a943.png";